/**
 * Remove given search params, while keeping the rest of the URI, including other search params. Does not reload the page.
 * @param keys search params to remove
 */
export function eraseSearchParams(...keys: string[]) {
  const params = new URLSearchParams(window.location.search);
  keys.forEach((key) => params.delete(key));
  history.replaceState({}, '', `?${params.toString()}`);
}
